'use strict';

import React, { PropTypes } from 'react';
import createStoreMixin from '../mixins/createStoreMixin';
import UserStore from '../stores/UserStore';
import ZineStore from '../stores/ZineStore';
import ZineDraftStore from '../stores/ZineDraftStore';
import UserLink from '../atoms/UserLink';
import shallowEqual from 'react/lib/shallowEqual';
import ScreenSizeMixin from '../mixins/ScreenSizeMixin';
import PureRenderMixin from '../mixins/PureRenderMixin';
import ZineStatus from '../constants/ZineStatus';
import Icon from '../atoms/Icon';

const ZineNavHeader = React.createClass({
  mixins: [createStoreMixin(UserStore, ZineStore, ZineDraftStore), ScreenSizeMixin, PureRenderMixin],

  propTypes: {
    zineSlug: PropTypes.string,
    isEditing: PropTypes.bool.isRequired
  },

  getStateFromStores(props) {
    const zine = props.isEditing ?
      ZineDraftStore.getActiveDraft() :
      ZineStore.get(props.zineSlug);

    let curator;
    if (zine) {
      curator = UserStore.get(zine.curator);
    }

    return { zine, curator };
  },

  componentWillReceiveProps(nextProps) {
    if (!shallowEqual(nextProps, this.props)) {
      this.setState(this.getStateFromStores(nextProps));
    }
  },

  render() {
    const { isMobile, zine, curator } = this.state;
    if (!zine || !curator) {
      return null;
    }

    const isUnlisted = zine.status === ZineStatus.UNLISTED;
    return (
      <span>
        Collection curated by <UserLink user={curator} bold />
        {isUnlisted &&
          <span title='This Collection is only visible to those with the direct link to it.'>
            <Icon name='eyeCrossed'
                  mode='fill'
                  size={isMobile ? 'xsmall' : 'small'}
                  margin='left' />
          </span>
        }
      </span>
    );
  }
});

export default ZineNavHeader;



/** WEBPACK FOOTER **
 ** ./molecules/ZineNavHeader.jsx
 **/